module.exports = __webpack_public_path__ + "img/79.8465680d.jpg";